import React, { useState } from 'react';

import Modal from '../base/Modal';
import { fieldsToSchema } from '../NewWorkflow/utils/schemaUtils';

const ConditionalNodeModal = ({
  mode,
  nodeData,
  onSave,
  onDelete,
  onClose,
  viewOnly,
}) => {
  const [condition, setCondition] = useState(nodeData?.data?.condition || '');

  const handleSave = () => {
    const outputFields = [
      {
        id: 'condition',
        fieldName: 'condition',
        dataType: 'Boolean',
        children: [],
      },
      {
        id: 'reasoning',
        fieldName: 'reasoning',
        dataType: 'String',
        children: [],
      },
    ];
    const schema = fieldsToSchema(outputFields);

    const updatedNode = {
      ...nodeData,
      data: { condition, jsonOutput: true, jsonOutputSchema: schema },
    };
    onSave(updatedNode);
  };

  return (
    <Modal
      title={
        viewOnly
          ? 'Conditional Node'
          : mode === 'add'
            ? 'Add Conditional Node'
            : 'Edit Conditional Node'
      }
      isOpen={true}
      onClose={onClose}
    >
      <div className="overflow-auto rounded p-6 shadow-lg">
        <textarea
          className="w-full resize-none rounded-md border border-zinc-700 bg-zinc-800 px-3 py-2
          text-zinc-100 placeholder-zinc-500 transition duration-200 focus:border-transparent
          focus:outline-none focus:ring-2 focus:ring-[#5652CF]"
          value={condition}
          disabled={viewOnly}
          rows={4}
          placeholder="e.g. Mail is related to UI Issue"
          onChange={(e) => setCondition(e.target.value)}
        />
        {!viewOnly && (
          <div className="mt-2 flex justify-end gap-3">
            {mode === 'edit' && (
              <button
                className="rounded-md border border-zinc-700 bg-zinc-800 px-4 
                py-2 text-zinc-300 transition duration-200 hover:bg-zinc-700
                focus:outline-none focus:ring-2 focus:ring-zinc-500"
                onClick={() => onDelete(nodeData.id)}
              >
                Delete Node
              </button>
            )}
            <button
              // className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
              className="rounded-md border border-zinc-700 bg-zinc-800 px-4 
              py-2 text-zinc-300 transition duration-200 hover:bg-zinc-700
              focus:outline-none focus:ring-2 focus:ring-zinc-500"
              onClick={handleSave}
            >
              {mode === 'add' ? 'Add Node' : 'Save Changes'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConditionalNodeModal;
